export default "__VITE_ASSET__Dm1UrSHo__"